export enum Routes {
  Root = "/",
  Login = "/login",
  ImplicitCallback = "/implicit/callback",
}
